import {
  ADD_ITEM_DETAIL,
  EDIT_ITEM_DETAIL,
  DELETE_ITEM_DETAIL,
  SELECT_ITEM_DETAIL,
  CLEAR_ITEM_DETAILS,
} from "../../constants/types";

export const addItemDetail = (item) => ({
  type: ADD_ITEM_DETAIL,
  payload: item,
});

export const editItemDetail = (item, itemIdx) => ({
  type: EDIT_ITEM_DETAIL,
  payload: { item, itemIdx },
});

export const deleteItemDetail = (itemIdx) => ({
  type: DELETE_ITEM_DETAIL,
  payload: itemIdx,
});

export const selectItemDetail = (itemIdx) => ({
  type: SELECT_ITEM_DETAIL,
  payload: itemIdx,
});

export const clearItemDetails = () => ({
  type: CLEAR_ITEM_DETAILS,
});
